var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog-loader',{attrs:{"visible":!_vm.assistances}}),(_vm.assistances)?_c('dashboard',{attrs:{"assistances":_vm.assistances,"refresh":_vm.reFetchAssistances}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }